export enum NotificationType {
  CONTACT_REQUEST_CREATED = 'CONTACT_REQUEST_CREATED',
  CONTACT_REQUEST_ANSWERED = 'CONTACT_REQUEST_ANSWERED',
  CALENDAR_EVENT_UPCOMING = 'CALENDAR_EVENT_UPCOMING',
  KEEP_CONTACT_REMINDER = 'KEEP_CONTACT_REMINDER',
  SCHEDULED_MESSAGE_UPCOMING = 'SCHEDULED_MESSAGE_UPCOMING',
  BIRTHDAY_UPCOMING = 'BIRTHDAY_UPCOMING',
}

export enum ContactRequestAnswer {
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
}

export interface ContactRequestCreatedNotificationData {
  contactRequestId: string
  senderId: string
}

export interface ContactRequestAnsweredNotificationData {
  contactRequestId: string
  recipientId: string
  answer: ContactRequestAnswer
}

export interface CalendarEventUpcomingNotificationData {
  calendarEventId: string
  participantAccountIds?: string[]
  startDateTime: string
}

export interface KeepContactReminderNotificationData {
  keepContactId: string
  contactId: string
  keepDate: string
}

export interface ScheduledMessageUpcomingNotificationData {
  scheduledMessageId: string
  contactId: string
  scheduledAt: string
}

export interface BirthdayUpcomingNotificationData {
  contactId: string
  birthDate: string
}

export type NotificationData =
  | ContactRequestCreatedNotificationData
  | ContactRequestAnsweredNotificationData
  | CalendarEventUpcomingNotificationData
  | KeepContactReminderNotificationData
  | ScheduledMessageUpcomingNotificationData
  | BirthdayUpcomingNotificationData

export interface Notification {
  id: string
  type: NotificationType
  data: NotificationData
  recipientId: string
  pushedAt: string | null
  readAt: string | null
  createdAt: string
  updatedAt: string
}

